// extracted by mini-css-extract-plugin
module.exports = {"tablet":"(max-width: 1024px)","modal__root":"modal__root-2rET6","modal__paper":"modal__paper-1L-kI"};